// import 'bootstrap';
export const confirmationMixin = {
    methods: {
        /**
         * Creates a prompt message if needed and executes callback function on success and deniedCallback on failure.
         * @function
         * @param {Prompt} promptObj Prompt object with callback and prompt text.
         * @param {boolean} toPrompt Whether to prompt or not.
         * @param {String} [confirmationRef=bo_confirmation] Name of the confirmation component.
         */
        async boPromptIfNeeded(promptObj, toPrompt = true, confirmationRef = "bo_confirmation") {
            if (toPrompt) {
                const confirm = await this.$refs[confirmationRef].activate(
                    promptObj.message.title,
                    promptObj.message.body,
                    promptObj.message.confirmText,
                    promptObj.message.type
                );
                if (confirm) {
                    return promptObj.callback(promptObj.data);
                } else {
                    if (promptObj.deniedCallback != null) return promptObj.deniedCallback();
                    else return null;
                }
            } else {
                return promptObj.callback();
            }
        },

        /**
         * If the confirmation component has a predefined body, then just activate the modal as is.
         * @function
         * @param {Prompt} promptObj Prompt object with callback.
         * @param {boolean} toPrompt Whether to prompt or not.
         * @param {String} [confirmationRef=bo_confirmation] Name of the confirmation component.
         */
        async boPromptStaticIfNeeded(promptObj, toPrompt = true, confirmationRef = "bo_confirmation") {
            if (toPrompt) {
                const confirm = await this.$refs[confirmationRef].activateStatic();
                if (confirm) {
                    return promptObj.callback(promptObj.data);
                } else {
                    if (promptObj.deniedCallback != null) return promptObj.deniedCallback();
                    else return null;
                }
            } else {
                return promptObj.callback();
            }
        },

        /**
         * Creates a prompt message if needed and executes callback function on success and deniedCallback on failure.
         * @function
         * @param {Prompt} promptObj Prompt object with callback and prompt text.
         * @param {boolean} toPrompt Whether to prompt or not.
         * @param {String} [confirmationRef=bo_confirmation] Name of the confirmation component.
         */
        async boPromptMultipleTimeIfNeeded(
            promptObjs,
            toPrompt = true,
            index = 0,
            confirmationRef = "bo_confirmation"
        ) {
            if (promptObjs.length > index) {
                if (toPrompt) {
                    const confirm = await this.$refs[confirmationRef].activate(
                        promptObjs[index].message.title,
                        promptObjs[index].message.body,
                        promptObjs[index].message.confirmText,
                        promptObjs[index].message.type
                    );
                    if (confirm) {
                        this.boPromptMultipleTimeIfNeeded(promptObjs, toPrompt, index + 1, confirmationRef);
                        return promptObjs[index].callback(promptObjs[index].data);
                    } else {
                        if (promptObjs[index].deniedCallback != null) {
                            this.boPromptMultipleTimeIfNeeded(promptObjs, toPrompt, index + 1, confirmationRef);
                            return promptObjs[index].deniedCallback();
                        } else {
                            this.boPromptMultipleTimeIfNeeded(promptObjs, toPrompt, index + 1, confirmationRef);
                            return null;
                        }
                    }
                } else {
                    this.boPromptMultipleTimeIfNeeded(promptObjs, toPrompt, index + 1, confirmationRef);
                    return promptObjs[index].callback();
                }
            }
        },
    },
};

export default confirmationMixin;
